import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { NoConnectionIcon } from 'shared/ui/icons';

export const NoInternet = ({ handleRetry = null }) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  const redirectTryAgain = () => {
    if (typeof handleRetry === 'function') {
      handleRetry();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="w-full absolute bg-white z-50 left-0 top-0 content-center h-screen flex flex-col items-center">
      <div className="flex flex-col items-center justify-center h-full w-[50%]">
        <div className="flex flex-col justify-center items-center text-center gap-y-4">
          <div className="p-4 rounded-lg bg-[#FFFBFA] border border-[#FECDCA]">
            <NoConnectionIcon />
          </div>
          <>
            <span className="font-medium text-2xl">
              {t('error_network_title')}
            </span>
            <span className="font-normal text-base">
              {t('error_network_description')}
            </span>
          </>
          <button
            type="button"
            onClick={() => redirectTryAgain()}
            className="border rounded-md py-2 px-3 text-base w-fit text-md font-semibold bg-[#6CA1F0] text-white items-self-center cursor-pointer"
          >
            {t('action_try_again')}
          </button>
        </div>
      </div>
    </div>
  );
};
